/* eslint-disable import/prefer-default-export */

/* eslint-disable consistent-return */
import { useRef, useEffect } from 'react';
import { accessible } from './accessibility';
export var useEventListener = function useEventListener(eventName, handler) {
  var element = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : window;
  var savedHandler = useRef();
  useEffect(function () {
    savedHandler.current = handler;
  }, [handler]);
  useEffect(function () {
    var isSupported = element && element.addEventListener;
    if (!isSupported) return;

    var eventListener = function eventListener(event) {
      return savedHandler.current(event);
    };

    element.addEventListener(eventName, eventListener);
    return function () {
      element.removeEventListener(eventName, eventListener);
    };
  }, [eventName, element]);
};
export var useAccessibleKeyboardNavigationHandler = function useAccessibleKeyboardNavigationHandler(ref, escapeCb) {
  return function (event) {
    var key = event.key;

    var _accessible = accessible(ref.current),
        navigateToNextChild = _accessible.navigateToNextChild,
        navigateToPrevChild = _accessible.navigateToPrevChild;

    if (key === 'ArrowDown') navigateToNextChild();
    if (key === 'ArrowUp') navigateToPrevChild();
    if (key === 'Escape' && typeof escapeCb === 'function') escapeCb(event);
  };
};
export var useOutsideClickListener = function useOutsideClickListener(ref, cb) {
  useEffect(function () {
    var handleEvent = function handleEvent(event) {
      var current = ref.current;

      if (current && !current.contains(event.target) && typeof cb === 'function') {
        cb(event);
      }
    };

    document.addEventListener('mousedown', handleEvent);
    return function () {
      document.removeEventListener('mousedown', handleEvent);
    };
  }, [cb, ref]);
};